import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "/api";
console.log(BASE_URL, "BASE_URL");
// Create axios instance with default config
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 30000, // 30 seconds
  headers: {
    "Content-Type": "application/json",
  },
});

let onUnauthorized = null;

export const registerUnauthorizedHandler = (handler) => {
  onUnauthorized = handler;
};

// Request interceptor for adding auth token AND API key
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const apiKey = localStorage.getItem("apiKey"); // Get API key from localStorage

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Add API key header for API endpoints that require it
    if (apiKey) {
      config.headers["x-api-key"] = apiKey;
    }

    // If data is FormData, remove Content-Type to let browser set it with boundary
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }

    return config;
  },
  (error) => {
    console.error("Request interceptor error:", error);
    return Promise.reject(error);
  }
);

// Response interceptor for handling errors
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      if (onUnauthorized) onUnauthorized();
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

/**
 * Make HTTP GET request
 * @param {string} url - API endpoint
 * @param {object} params - Query parameters
 * @returns {Promise} - Response data
 */
export const get = async (url, params = {}) => {
  try {
    const backendUrl = process.env.REACT_APP_API_BASE_URL || "/api";
    console.log(backendUrl, "url");
    const response = await axiosInstance.get(`${backendUrl}${url}`, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Make HTTP POST request
 * @param {string} url - API endpoint
 * @param {object} data - Request body
 * @param {object} config - Additional axios config
 * @returns {Promise} - Response data
 */
export const post = async (url, data = {}, config = {}) => {
  try {
    const response = await axiosInstance.post(url, data, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Make HTTP PUT request
 * @param {string} url - API endpoint
 * @param {object} data - Request body
 * @param {object} config - Additional axios config
 * @returns {Promise} - Response data
 */
export const put = async (url, data = {}, config = {}) => {
  try {
    const response = await axiosInstance.put(url, data, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Make HTTP DELETE request
 * @param {string} url - API endpoint
 * @returns {Promise} - Response data
 */
export const del = async (url) => {
  try {
    const response = await axiosInstance.delete(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};
